const skills = [
  {
    link: 'https://www.ruby-lang.org/en/',
    tech: 'Ruby',
  },
  {
    link: 'https://rubyonrails.org/',
    tech: 'Rails',
  },
  {
    link: 'https://www.javascript.com/',
    tech: 'JavaScript',
  },
  {
    link: 'https://www.typescriptlang.org/',
    tech: 'TypeScript',
  },
  {
    link: 'https://reactjs.org/',
    tech: 'React',
  },
  {
    link: 'https://redux.js.org/',
    tech: 'Redux',
  },
  {
    link: 'https://nextjs.org/',
    tech: 'NextJS',
  },
  {
    link: 'https://reactnative.dev/',
    tech: 'React Native',
  },
  {
    link: 'https://graphql.org/',
    tech: 'GraphQL',
  },
];

export default skills;
